import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentRoom1 } from "./ContentRoom1"
import { Balloon } from "./Balloon"
import { Help } from "./Help"

import { Clock } from "./Clock"
// {...(props.step >= 3) && {onClick:{() => props.onChangeStep(1)}}
import "./../assets/scss/Room1.scss";


export const Room1 = (props) => {

    const steps = {
      "b_preintro" : ["intro pre", ""],
      "b_intro" : ["intro", ""],
      "f_marge1" : ["", ""],
      "b_marge1a" : ["right", "follow"],
      "b_marge1b" : ["right", "follow"],
      "b_marge1c" : ["right", "follow"],
      "b_marge1d" : ["right", "close"],
      "f_lettera" : ["", ""],
      "b_lettera" : ["image link", "close"],
      "f_marge2" : ["", ""],
      "b_marge2a" : ["right", "follow"],
      "b_marge2b" : ["right", "follow"],
      "b_marge2c" : ["right", "close"],
      "f_bacheca" : ["", ""],
      "b_bacheca" : ["slide link", "close"],
      "f_computer" : ["", ""],
      "b_computer" : ["image link", "close"],
      "f_help" : ["", ""],
      "b_help" : ["help", "close"],
      "risposta" : ["", ""],
      "b_exit" : ["exit", ""]
    };

  React.useEffect(() => {
    if(props.step == Object.keys(steps).indexOf("risposta")) props.onNextHelp();
  }, [props.step]);



  const books1 = [];
  const books2 = [];
  const polaroids = [];
  const righe = [];

  for (let i = 0; i < 12; i++) {
    books1.push(<div className="book" key={i}  />);
  }

  for (let i = 0; i < 6; i++) {
    books2.push(<div className="book" key={i}  />);
  }

  for (let i = 0; i < 5; i++) {
    polaroids.push(<div className="polaroid" key={i}><div className="color" /></div>);
  }

  for (let i = 0; i < 4; i++) {
    righe.push(<div className="riga" key={i} />);
  }

    return(
      <div className="room1">
        <div className="pavimento"></div>
        <div className="parete"><div className="texture"></div></div>



        <button className={`bacheca ${(props.step >= Object.keys(steps).indexOf("f_bacheca")) ? "active" : "unactive"}`} onClick={() => props.step >= Object.keys(steps).indexOf("f_bacheca") ? props.onChangeStep(Object.keys(steps).indexOf("b_bacheca")) : false }>
          {(props.step == Object.keys(steps).indexOf("f_bacheca")) &&
            <CommonSvgContent stringToRet="click" />
          }
          {(props.step > Object.keys(steps).indexOf("f_bacheca")) &&
            <div className="clickable" />
          }

          <div className="appSx" /><div className="appDx" />
          <div className="fondoBacheca">
            {polaroids}
            <div className="poster">
              {righe}
              <ContentRoom1 stringToRet="atom" />
            </div>
          </div>
        </button>

        <div className="areaFinestra">
          <div className='finestra'>
            <ContentRoom1 stringToRet="finestra" />
          </div>

          <div className='bb8'>
            <ContentRoom1 stringToRet="bb8" />
          </div>
        </div>

        <div className='tappeto'>
          <ContentRoom1 stringToRet="tappeto" />
        </div>

        <div className="areaScrivania">
          <div className="piano">
            <button className={`computer
                ${(props.step >= Object.keys(steps).indexOf("f_computer")) ? "active" : "unactive"}`}
                onClick={() => props.step >= Object.keys(steps).indexOf("f_computer") ? props.onChangeStep(Object.keys(steps).indexOf("b_computer")) : false }>
              {(props.step == Object.keys(steps).indexOf("f_computer")) &&
                <CommonSvgContent stringToRet="click" />
              }
              {(props.step > Object.keys(steps).indexOf("f_computer")) &&
                <div className="clickable" />
              }
              <ContentRoom1 stringToRet="computer" />
            </button>

            <button className={`lettera ${(props.step >= Object.keys(steps).indexOf("f_lettera")) ? "active" : "unactive"}`}
                    onClick={() => props.step >= Object.keys(steps).indexOf("f_lettera") ? props.onChangeStep(Object.keys(steps).indexOf("b_lettera")) : false }>
              {(props.step == Object.keys(steps).indexOf("f_lettera")) &&
                <CommonSvgContent stringToRet="click" />
              }
              {(props.step > Object.keys(steps).indexOf("f_lettera")) &&
                <div className="clickable" />
              }
              <ContentRoom1 stringToRet="lettera" />
            </button>
            <div className='tacquino'>
              <CommonSvgContent stringToRet="tacquino" />
            </div>
          </div>
          <div className="cornice"></div>
          <div className="gambadx"></div>
          <div className="gambasx"></div>
        </div>

        <div className="libreria">
          <div className="scaffale1"><div className="books books1">{books1}</div></div>
          <div className="scaffale2">
            <button className="cappello active" onClick={() => false }>
              <ContentRoom1 stringToRet="cappello" />
            </button>
            <div className="books books2">
              <div className="book" /><div className="book" />
            </div>
          </div>
          <div className="scaffale3"><div className="books books3">{books1}</div></div>
          <div className="scaffale4">
            <div className="books books4">{books2}</div>
            <button className="delorean active" onClick={() => false }>
              <ContentRoom1 stringToRet="delorean" />
            </button>
          </div>
          <div className="scaffale5">
            <div className="scatola"><div className="top" /><div className="bottom" /></div>
            <div className="scatola"><div className="top" /><div className="bottom" /></div>
          </div>
          <div className="spallaDx"></div>
          <div className="zoccolo"></div>
        </div>

        <div className={`areaTelefono ${(props.step == Object.keys(steps).indexOf("risposta")) ? "help3 ringing" : ""}`}>
          <div className="pianoUnder" />
          <div className="pianoOver">
            <button className={`telefono
                ${(props.step >= Object.keys(steps).indexOf("f_help")) ? "active" : "unactive"}`}
                onClick={() => props.step >= Object.keys(steps).indexOf("f_help") ? props.onChangeStep(Object.keys(steps).indexOf("b_help")) : false }>
              <CommonSvgContent stringToRet="telefono" />
              {(props.step == Object.keys(steps).indexOf("f_help")) &&
                <CommonSvgContent stringToRet="click" />
              }
            </button>

            <div className="helpsWrapper">
              <div className="helps">
              <button className="helpclick1 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 1) : false }>1</button>
              <button className="helpclick2 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 2) : false }>2</button>
              <button className="helpclick3 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 3) : false }>3</button>
              </div>
            </div>
          </div>
        </div>

        <button
          className={`marge ${(props.step >= Object.keys(steps).indexOf("f_marge1")) ? "active" : "unactive"}`}
          onClick={() => props.step >= Object.keys(steps).indexOf("f_marge1") &&  props.step < Object.keys(steps).indexOf("f_marge2") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge1a")) :
                         props.step >= Object.keys(steps).indexOf("f_marge2") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge2a")) : false } >
          {(props.step == Object.keys(steps).indexOf("f_marge1") ||
            props.step == Object.keys(steps).indexOf("f_marge2")) &&
            <CommonSvgContent stringToRet="click" />
          }
          {(props.step > Object.keys(steps).indexOf("f_marge1") && props.step < Object.keys(steps).indexOf("f_marge2") ||
            props.step > Object.keys(steps).indexOf("f_marge2")) &&
            <div className="clickable" />
          }
          <CommonSvgContent stringToRet="marge" />
        </button>

        {(props.step == Object.keys(steps).indexOf("risposta")) &&
          <div className="risposta">
            {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}

            <div className="rispostaCont">
              <p>Inserisci qui la password</p>
              <form onSubmit={(e) => props.onSubmitAnswer(e, "room1", Object.keys(steps).indexOf("risposta"))}>
                <input type="text" placeholder="" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} />
                <input type="submit" value="OK" />
              </form>
              <p>2 caratteri senza spazi</p>
            </div>
          </div>
        }

        {(props.helpopen != 0) &&
          <Help room={props.room} clickon={`help${props.helpopen}`} onNextHelp={props.onNextHelp} />
        }

        {(Object.keys(steps).length > props.stepnow && Object.keys(steps)[props.stepnow].startsWith("b_")) &&
          <Balloon type={steps[Object.keys(steps)[props.stepnow]][0]} room={props.room} clickon={Object.keys(steps)[props.stepnow]} button={steps[Object.keys(steps)[props.stepnow]][1]} interaction={false} onChangeStep={props.onChangeStep} onChangeStep={props.onChangeStep} onChangeRoom={props.onChangeRoom} />
        }

      </div>
    )
}
